<template>
  <router-link class="dashboard-task" :to="getUrl()" target="_blank">
    <card dis-hover :padding="8" class="dashboard-task-card">
      <div class="dashboard-task-container">
        <div class="dashboard-task-left">
          <tag :color="getDateColor()">
            {{ task.expiration_date }}
          </tag>
          <i-button
            v-if="task.manual_done"
            @click.prevent="completeTask"
            type="success"
            size="small"
          >
            Завершить
          </i-button>
        </div>
        <div class="dashboard-task-right">
          <div class="dashboard-task-header">
            <div class="dashboard-task-common">
              <span class="ms-small-head">
                {{ task.name }}
              </span>
            </div>
            <!-- <badge dot color="blue">
              <icon class="ms-help" size="20" type="ios-chatbubbles" />
            </badge> -->
          </div>
          <div v-if="!!task.object" class="dashboard-task-text ms-text">
            Шифр: {{ task.object.code }}. Заказчик: {{ task.object.customer.name }}
          </div>
          <div class="dashboard-task-additional ms-help ms-ellipsis">
            {{ task.object.name }}
          </div>
        </div>
      </div>
    </card>
  </router-link>
</template>

<script>
import moment from 'moment'

export default {
  props: ['task'],
  methods: {
    getUrl () {
      return `/app/contracts/${this.task.object_id}/overview`
    },
    async completeTask () {
      try {
        const url = `page/workflow/${this.task.id}?action=done`
        await this.$store.dispatch('PUT_REQUEST', { url })

        this.$store.commit('SET_DASHBOARD_PROP', ['needToUpdate', true])
      } catch (error) {
        console.log(error)
      }
    },
    getDateColor () {
      const diff = moment(this.task.expiration_date, 'YYYY-MM-DD').diff(
        moment(),
        'days'
      )

      if (diff < 0) return 'red'
      if (diff < 3) return 'gold'

      return 'default'
    }
  }
}
</script>

<style lang="less">
.dashboard-task {
  & {
    display: block;

    &:not(:first-child) {
      margin-top: 8px;
    }
  }

  &-card {
    &:hover {
      border-color: rgba(@primary-color, 0.6) !important;
    }
  }

  &-text {
    margin-top: 4px;
  }

  &-container {
    display: flex;
    align-items: stretch;
  }

  &-left {
    margin-right: 8px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    width: 96px;

    .ivu-tag {
      flex: 1;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ivu-btn {
      margin-top: 8px;
    }
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ivu-badge-dot {
      top: 0;
      right: -4px;
      width: 6px;
      height: 6px;
      // background: @primary-color;
    }
  }

  &-additional {
    width: 464px;
    display: inline-block;
    margin-bottom: -6px;
  }
}
</style>
